import { Component, Input } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

// COMPONENTS
import { DialogConfig } from '../../../shared/configs';
import { ClientProfileDialogComponent } from '../client-profile-dialog/client-profile-dialog.component';

// CONFIGS

// INTERFACES
import { ICompany } from './../../../client/interfaces/client-company.interface';

@Component({
  selector: 'lum-client-profile-create',
  templateUrl: './client-profile-create.component.html',
  styleUrls: ['./client-profile-create.component.scss'],
})
export class ClientProfileCreateComponent {
  @Input()
  client :ICompany | null;

  private onDestroy$ = new Subject();

  constructor(private dialog :MatDialog) {}

  onOpenDialog() :void {
    this.dialog
      .open(ClientProfileDialogComponent, {
        data: {
          client: this.client,
        },
        width: DialogConfig.sizes.medium,
        maxHeight: '750px',
        disableClose: true,
      })
      .afterClosed()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((client) => {
        if (client) {
          // TODOS: patch values to main form
        }
      });
  }

  get mode() :string {
    return this.client ? 'Update' : 'Create';
  }
}
